<script setup lang="ts">
import type { PlanName } from '~/composables/usePlanConfig'

const props = defineProps<{
  plan: PlanName
  size?: 'xs' | 'sm'
}>()

const badgeColor = computed(() => {
  if (props.plan === 'elite') return 'warning' as const
  if (props.plan === 'pro') return 'fuchsia' as const
  return 'neutral' as const
})

const label = computed(() => {
  return props.plan.charAt(0).toUpperCase() + props.plan.slice(1)
})
</script>

<template>
  <UBadge
    :color="badgeColor"
    variant="subtle"
    :size="size ?? 'xs'"
  >
    {{ label }}
  </UBadge>
</template>
